import { Component, Injectable, OnInit, Input, Compiler } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Route, Router } from '@angular/router';

import { AuthenticationService } from '../../../../../../app/services/authentication.service';
import { AlertService } from '../../../../../../app/utils/alert.service';
import { BindComponentService } from "../../../../../../app/utils/bind.component.service";
import { HibridModalComponent } from '../hibridModal/content.component';

/**
 * @version $Id: content.component.ts 62312 2017-09-12 17:39:13Z bernardo.d.siqueira $
 */
@Component({
  selector: 'packageHireModal',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class PackageHireModalComponent implements OnInit {

  @Input() textNewService: string;
  @Input() calledFromLogin: boolean;
  @Input() isHibrid: boolean;
  @Input() textHibrid: string;

  constructor(private activeModal: NgbActiveModal,
    private authService: AuthenticationService,
    private alertService: AlertService,
    private bindComponent: BindComponentService,
    private router: Router,
    private modalService: NgbModal ) {
  }

  ngOnInit() {
    if(this.calledFromLogin) {
      this.getNewServiceText();
    }
	document.getElementsByClassName("modal-dialog")[0] && document.getElementsByClassName("modal-dialog")[0].classList.add("modal-welcome");
  };

  private close() {
    this.activeModal.dismiss();
    if(this.isHibrid) {
      let modalRef = this.modalService.open(HibridModalComponent);
      modalRef.componentInstance.textHibrid = this.textHibrid;
    }
  }

  private getNewServiceText() {
    this.authService.getWelcomeText().subscribe(
      data => {
        this.textNewService = data['PackageHireMessage'];
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  public redirect(andress:string){
    this.router.navigate([andress], { queryParams: {openLine:true} });
    this.activeModal.dismiss();
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/welcome/packageHire/content.component.ts